import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GENERACION_ENLACES } from 'constants/routeNames';
import PropTypes from 'prop-types';
import { CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import Modal from '../../Modal/Modal';
import ImgExito from '../../../assets/images/Enlaces/ID_enlaces.svg';
import './EnlacesModal.scss';

const EnlacesModal = ({ visible, onClose, idEnlace }) => {
  const [tooltipText, setTooltipText] = useState('Copiar ID del enlace');
  const navigate = useNavigate();

  const handleClose = () => {
    setTooltipText('Copiar ID del enlace');
    onClose?.();
  };
  const handleOK = () => {
    navigate(GENERACION_ENLACES);
  };
  const handleCopy = () => {
    // Copy the text inside the text field
    navigator.clipboard.writeText(idEnlace);

    // Alert the copied text
    setTooltipText(`Copiado: ${idEnlace}`);
  };
  return (
    <Modal
      title=""
      key={idEnlace}
      visible={visible}
      width="43em" // Se establece el tamaño asi por que antd sobreescribe el tamaño que se le pasa por clase
      onCancel={handleClose}
      onOk={handleOK}
      okText="Ir a Generación de enlaces"
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{
        style: {
          borderColor: '#da1188',
          color: '#da1188',
          background: '#ffffff',
          fontSize: '12px',
          padding: '10px'
        }
      }}>
      <div className="download-modal">
        <img className="download-modal-imagen" alt="GuardadoCorrecto" src={ImgExito} />
        <span className="download-modal-descripcion">
          Petición agregada a la cola de generación de enlaces.
        </span>
        <div className="id-download-box">
          <span className="id-download-descripcion">ID del enlace: </span>
          <span className="id-download">{idEnlace}</span>
          <Tooltip title={tooltipText}>
            <CopyOutlined style={{ color: '#da1188' }} onClick={handleCopy} />
          </Tooltip>
        </div>
      </div>
    </Modal>
  );
};

EnlacesModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  idEnlace: PropTypes.string.isRequired
};

export default EnlacesModal;
